import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { makeStyles } from '@material-ui/core/styles';

export default function ChevronIcon({isOpen, customStyles}) {
    const useStyles = makeStyles((theme) => ({
        icon: {
            ...customStyles,
            color: '#2057AD',
            fontSize: '20px',
            fontStyle: 'normal',
            fontWeight: 900,
            lineHeight: 'normal',
        },
    }));
    const classes = useStyles();
    return <FontAwesomeIcon className={classes.icon} icon={faChevronDown} />;
}